import { CameraFrustumViewer } from 'app/modules/wallforming/components/frustum-viewer/CameraFrustumViewer';

export const FrustumViewerPage = () => {
    return <CameraFrustumViewer />;
};
